import type { AgentStructuredQuestion } from '@/apis/logiblocksAgentAPI';

/** Convert ordinary composer text into the same values a question card sends. */
export function composerAnswerValues(
  question: AgentStructuredQuestion,
  rawText: string
): string[] {
  const text = rawText.trim();
  if (!text) return [];
  if (question.kind === 'text') return [text];

  const byLabelOrValue = new Map<string, string>();
  for (const choice of question.choices) {
    if (choice.disabled) continue;
    byLabelOrValue.set(choice.label.trim().toLowerCase(), choice.value);
    byLabelOrValue.set(choice.value.trim().toLowerCase(), choice.value);
  }

  const parts =
    question.kind === 'single_select'
      ? [text]
      : text.split(/\s*(?:,|\band\b)\s*/i).filter(Boolean);
  const resolved = parts.map((part) =>
    byLabelOrValue.get(part.trim().toLowerCase())
  );
  if (resolved.every((value): value is string => Boolean(value))) {
    return [...new Set(resolved)];
  }
  return question.allow_other ? [text] : [];
}
